import { Component, OnInit, inject } from "@angular/core";
import { AuthAmplifyService } from "src/app/shared/service/auth-amplify.service";
import { Router } from "@angular/router";

@Component({
  selector: 'app-authenticate',
  templateUrl: './authenticate.component.html',
  styleUrls: ['./authenticate.component.scss'],
  standalone: true,
})
export class AuthenticateComponent implements OnInit {
  isLoggedInUser = false;
  loggedInUserData: any;

  private readonly authService = inject(AuthAmplifyService);
  private readonly router = inject(Router);

  ngOnInit(): void {
    localStorage.clear();
    this.proxyLogin();
  }

  proxyLogin() {
    this.authService.proxyLogin().subscribe((response: { data: string; }) => {
      this.navigate(response.data);
      localStorage.setItem('loggedIn', 'true')
    });
  }

  navigate(url: string) {
    window.location.assign(url);
  }

  login() {
    this.authService.signIn();
  }

}